export type DiscoverTab = "forYou" | "recentlyPlayed" | "latest" | "popular" | "following";

export function discoverFeedTab(value: unknown): DiscoverTab | null {
	switch (value) {
		case "for-you": return "forYou";
		case "recently-played": return "recentlyPlayed";
		case "latest": return "latest";
		case "popular": return "popular";
		case "following": return "following";
		default: return null;
	}
}

export function isPrivateDiscoverTab(tab: DiscoverTab | null): boolean {
	return tab === "recentlyPlayed" || tab === "following";
}
